export interface UserInfo {
  userId: number;
  oib: string;
  firstName: string;
  lastName: string;
  phone: string;
  email: string;
  institutionId: number;
  institutionName: string;
  roleId: number;
  roleName: string;
  isActive: boolean;
}

export const userInfoInitial = (roleId: number, institutionId: number): UserInfo => {
  return {
    userId: 0,
    oib: "",
    institutionId: institutionId,
    institutionName: "",
    firstName: "",
    lastName: "",
    phone: "",
    email: "",
    roleId: roleId,
    roleName: '',
    isActive: true
  }
}